module.exports = __webpack_public_path__ + "img/plus-circle-fill.5ec22a80.svg";